// extracted by mini-css-extract-plugin
export default {"button":"TopicItemMenu-module__button--y6cpJ","active":"TopicItemMenu-module__active--uqFBv","animatedBackground":"TopicItemMenu-module__animatedBackground--yLIzV"};